module.exports = __webpack_public_path__ + "static/media/Cardless_Cash.5625549f.svg";